export default class DataSettlementRequest {
  constructor(bRoot) {
    this.bRoot = bRoot;
    this.app = "/data/";
    this.initialize = this.initialize.bind(this);
  }

  async search(dealer_id, state_id, date_from, order, page) {
    let endpoint =
      this.app +
      "settlement_requests_hierarchy/" +
      dealer_id.toString() +
      "/" +
      state_id.toString() +
      "/" +
      date_from.toString() +
      "/" +
      (order ? order : "");

    return await this.bRoot.search(endpoint, null, null, null, page);
  }

  async getStates() {
    // eslint-disable-next-line
    return await this.bRoot.search(this.app + "settlement_request_states", null, "code", null);
  }

  async initialize(dealer) {
    let usd_rate_endpoint =
      this.app +
      "rate_values" +
      "/" +
      "to_date" +
      "/" +
      "USD" +
      "/" +
      this.bRoot.moment().format("YYYY-MM-DD");

    let usd_rate = await this.bRoot.search(usd_rate_endpoint, null, null, null);

    if (usd_rate.data.length == 0) {
      let error =
        "No existe cotización para la moneda USD, comuníquese con Administración";
      this.bRoot.setError(error);
      return null;
    } else {
      let object = {
        url: null,
        id: null,
        code: null,
        commercial_person: this.bRoot.appInfo.commercial_person.url,
        commercial_person_name: this.bRoot.appInfo.commercial_person.person.name, // eslint-disable-line
        dealer: null,
        dealer_object: null,
        dealer_name: null,
        dealer_id: null,
        dealer_code: null,
        date: this.bRoot.moment().format("YYYY-MM-DD"),
        usd_rate_date: this.bRoot.moment.utc(usd_rate.data[0].effective_date).format("YYYY-MM-DD"), // eslint-disable-line
        usd_rate_date_formatted: this.bRoot.moment.utc(usd_rate.data[0].effective_date).format("DD/MM/YYYY"), // eslint-disable-line
        usd_value: usd_rate.data[0].value,
        date_formatted: this.bRoot.moment().format("DD/MM/YYYY"),
        total_commission_usd: 0,
        total_commission_lc: 0,
        comments: "",
        backend_code: null,
        can_edit: true,
        can_request_invoicing: false,
        errors: null,
        state: null,
        state_description: null,
        settlement_request_items: []
      };
      /*Evaluar si el comercial logueado es agente del cliente en cuestión y auto completar*/
      object = await this.setDealer(object, dealer);
      return object;
    }
  }

  async setDealer(object, dealer, dealerUrl) {
    if (!dealer && dealerUrl) {
      try {
        this.bRoot.disableAlerts = true;
        dealer = await this.bRoot.getObjectByURL(dealerUrl);
      } catch {
        dealer = null;
      } finally {
        this.bRoot.disableAlerts = false;
      }
    }
    object.dealer_object = dealer;
    object.dealer = dealer ? dealer.dealer : null;
    object.dealer_id = dealer ? dealer.dealer_id : 0;
    object.dealer_code = dealer ? dealer.code : null;
    object.dealer_name = dealer ? dealer.name : null;
    object.settlement_request_items = [];
    object.total_commission_usd = this.getTotalCommission(object);
    object.total_commission_lc = this.getTotalCommissionLc(object);
    return object;
  }

  itemsActualize(object, selected_items) {
    /* purge existing items*/
    object.settlement_request_items.forEach(item => {
      let index = selected_items.findIndex(
        i => i.id === item.sale_commission_id
      );
      if (index === -1) {
        /* delte item*/
        object = this.deleteItem(object, item);
      }
    });
    /* add new items*/
    selected_items.forEach(selected_item => {
      /* verify exists*/
      let index = object.settlement_request_items.findIndex(
        i => i.sale_commission_id === selected_item.id
      );
      if (index === -1) {
        /* Add New Item */
        object = this.addNewItem(object, selected_item);
      }
    });
    object.total_commission_usd = this.getTotalCommission(object);
    object.total_commission_lc = this.getTotalCommissionLc(object);
    return object;
  }

  addNewItem(object, selected_item) {
    let maxId = 0;
    let dv = this.distinctValues(object.settlement_request_items, "dealer_id");

    if (object.dealer_id != selected_item.dealer_id) {
      throw {
        message:
          "Solicitud vinculada al distribuidor " +
          object.dealer_name +
          ", no puede incluir comisiones del distribuidor " +
          selected_item.dealer_name
      };
      // eslint-disable-next-line
    } else if (dv.length > 0 & !dv.includes(selected_item.dealer_id)
    ) {
      throw {
        message:
          "No puede ingresar comprobantes que pertenezcan a diferentes distribuidores"
      };
    } else {
      if (object.settlement_request_items.length > 0) {
        // eslint-disable-next-line
        maxId  = object.settlement_request_items.reduce((acc, cur ) => Math.max(acc, cur.item_number), object.settlement_request_items[0].item_number);
      }
      let newItem = {
        id: null,
        sale_commission: selected_item.url,
        sale_commission_id: selected_item.id,
        commission_usd: selected_item.claimable_usd,
        commission_lc: parseFloat(selected_item.claimable_usd * object.usd_value).toFixed(2), // eslint-disable-line
        sale_commission_code: selected_item.code,
        sale_code: selected_item.sale_code,
        client_name: selected_item.client_name,
        sale_invoice_code: selected_item.sale_invoice_code,
        sale_invoice_due_date_formatted:
          selected_item.sale_invoice_due_date_formatted,
        dealer_id: selected_item.dealer_id,
        dealer_name: selected_item.dealer_name
      };
      if (object.url) {
        newItem.settlement_request = object.url;
      }
      newItem.item_number = ++maxId;
      object.settlement_request_items.push(newItem);
    }
    return object;
  }

  deleteItem(object, item) {
    let index = object.settlement_request_items.findIndex(
      i => i.item_number === item.item_number
    );
    if (index != -1) {
      object.settlement_request_items.splice(index, 1);
      /* renum items */
      let item_number = 1;
      let new_items = object.settlement_request_items.map(new_item => {
        new_item.item_number = item_number;
        item_number += 1;
        return new_item;
      });
      object.settlement_request_items = new_items;
    }
    object.total_commission_usd = this.getTotalCommission(object);
    object.total_commission_lc = this.getTotalCommissionLc(object);
    return object;
  }

  getSelectedItems(object) {
    let selected_items = [];
    object.settlement_request_items.forEach(item => {
      let newItem = {
        id: item.sale_commission_id,
        dealer_id: item.dealer_id,
        url: item.sale_commission,
        claimable_usd: item.commission_usd,
        code: item.sale_commission_code,
        sale_code: item.sale_code,
        client_name: item.client_name,
        sale_invoice_code: item.sale_invoice_code,
        sale_invoice_due_date_formatted: item.sale_invoice_due_date_formatted,
        dealer_name: item.dealer_name
      };
      selected_items.push(newItem);
    });
    return selected_items;
  }

  async save(object, component) {
    object = await this.defaultValuesSettlementRequest(object);

    try {
      this.bRoot.errors = null;
      await this.validateSettlementRequest(object, component);

      let added = null;

      let configs = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      let formData = new FormData();
      formData.append("dealer", object.dealer);
      formData.append("commercial_person", object.commercial_person);
      formData.append("date", object.date);
      formData.append("comments", object.comments);
      formData.append("total_commission_usd", object.total_commission_usd);
      formData.append("usd_rate_date", object.usd_rate_date);
      formData.append("usd_value", object.usd_value);
      formData.append("total_commission_lc", object.total_commission_lc);
      formData.append("state", object.state);
      formData.append(
        "settlement_request_items",
        JSON.stringify(object.settlement_request_items)
      );

      // object.settlement_request_items.forEach((item) => formData.append("settlement_request_items", JSON.stringify(item)));

      if (object.code) {
        formData.append("code", object.code);
      }
      if (object.id) {
        formData.append("id", object.id);
      }
      if (object.invoice_file.size > 0) {
        formData.append("invoice", object.invoice_file);
      }
      if (object.backend_code) {
        formData.append("backend_code", object.backend_code);
      }
      if (object.errors) {
        formData.append("errors", object.errors);
      }
      if (object.url) {
        added = await this.bRoot.patch(formData, configs, object.url);
      } else {
        added = await this.bRoot.add(
          "/data/settlement_requests",
          null,
          formData,
          configs
        );
      }
      if (added) {
        return added;
      } else {
        throw "El registro no se guardo";
      }
    } catch (error) {
      if (!this.bRoot.errors) {
        this.bRoot.setError(error);
        return null;
      }
    }
  }

  async changeState(object, state_code) {
    let endpoint =
      "/data/settlement_requests/change_state/" +
      object.id.toString() +
      "/" +
      state_code.toString() +
      "/";
    await this.bRoot.axios.post(endpoint);
  }

  async defaultValuesSettlementRequest(object) {
    let defaultState = await this.bRoot.search(
      "/data/settlement_request_states",
      null,
      null,
      "default=true"
    );
    if (defaultState.data.results.length > 0) {
      object.state = defaultState.data.results[0].url;
    } else {
      object.state = null;
    }
    object.errors = null;
    return object;
  }

  async validateSettlementRequest(object, component) {
    /* Campo obligatorio Cliente */
    if (!object.dealer) {
      throw "Debe ingresar Distribuidor";
    }

    /* Campo obligatorio Comercial */
    if (!object.commercial_person) {
      throw "No se pudo identificar al comercial logueado";
    }

    /* Campo Obligatorio Estado */
    if (!object.state) {
      throw "No se ha definido estado por defecto, comuniquése con el administrador del sistema";
    }

    /* Validate items not empty */
    if (object.settlement_request_items.length === 0) {
      throw "El comprobante debe tener al menos un ítem";
    }

    /* Error en archivo adjunto*/
    if (object.fileError) {
      throw object.fileError;
    }

    /* validate settlement reuest ítems */
    await this.validateSettlementRequestItems(object, component);
  }

  async validateSettlementRequestItems(object) {
    for (let item of object.settlement_request_items) {
      await this.validateSettlementRequestItem(object, item);
    }
  }

  async validateSettlementRequestItem(object, item) {
    /* eslint-disable */
    if (!item.sale_commission) {
      throw {
        message: "Item '" + item.item_number.toString() + "' ingrese comprobante"
      };
    }
    if (this.bRoot.isNullOrEmpty(item, "commission_usd")) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' sin comisión liquidable"
      };
    }
    if (parseFloat(item.commission_usd) === 0) {
      throw {
        message:
          "Item '" +
          item.item_number.toString() +
          "' comisión a liquidar debe ser distinto de cero " +
          item.max_leader_discount.toString()
      };
    }

    if (object.dealer_id != item.dealer_id) {
      throw {
        message: 
          "Item '" +
          item.item_number.toString() +
          "' dato distribuidor en el ítem difiere de dato distribuidor en cabecera del comprobante "
      }
    }
    //validar que el item aún tenga comisión liquidable equivalente a comisión total usd
  }

  distinctValues = (array, key) => {
    let key_distinct = [...new Set(array.map(item => item[key]))];
    return key_distinct
  }

  getTotalCommission(object) {
    const total_commission_usd = object.settlement_request_items.reduce((accumulator, object) => {
      return accumulator + parseFloat(object.commission_usd);
    }, 0);
    return total_commission_usd.toFixed(2);
  }

  getTotalCommissionLc(object) {
    const total_commission_lc = object.settlement_request_items.reduce((accumulator, object) => {
      return accumulator + parseFloat(object.commission_lc);
    }, 0);
    return total_commission_lc.toFixed(2);
  }
}